import React from 'react';
import { Navigate, useNavigate, Link } from 'react-router-dom'

export default function HeroVotar() {


  const navigate = useNavigate();
  const navigateToPropuestas = (destino) => {
      const destinourl = '/propuestas/';
      navigate(destinourl);
  } 


  const navegarToVotar = (destino) => {
    document.getElementById('votar').scrollIntoView({behavior: 'smooth'})
  } 

  return (
<div className="container-fluid py-5" style={{
    background: 'linear-gradient(135deg, #0A4D2E 0%, #E91E63 100%)',
    boxShadow: 'inset 0 0 100px rgba(0,0,0,0.2)'
  }}>
    <div className="container py-5">
      <div className="row flex-lg-row-reverse align-items-center g-5 py-5">
        <div className="col-10 col-sm-8 col-lg-6">
          <div className="d-flex justify-content-center align-items-center h-100">
            <img src="https://www.trenquelauquen.gov.ar/wordpress/wp-content/uploads/voto-online.jpg" className="img-fluid" alt="PP23 Logo" style={{marginRight: '1rem'}} />

          </div>
        </div>
        <div className="col-lg-6">
          <h1 className="display-5 fw-bold text-white lh-1 mb-3" style={{textShadow: '2px 2px 4px rgba(0,0,0,0.5)'}}>Votar una propuesta</h1>
          <p className="lead text-light" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.5)'}}>Tu voz importa. Participá en la toma de decisiones sobre cómo invertir en el futuro de nuestra ciudad.</p>
          <div className="d-grid gap-2 d-md-flex justify-content-md-start">
            <button type="button" onClick={navegarToVotar} className="btn btn-light btn-lg px-4 me-md-2 fw-bold" style={{color: '#E91E63'}}>Votar ahora</button>
            <button type="button" onClick={navigateToPropuestas} className="btn btn-outline-light btn-lg px-4" style={{borderWidth: '2px'}}>Ver todas las popuestas</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  );
}